/** Тексты пространства «audit». Ключи именуются по смыслу, а не по месту. */
export const audit = {
  title: 'Кто и что менял',
  hint: 'Запись появляется сама вместе с действием и не редактируется. Снимок «было / стало» хранится ровно затем, чтобы разобрать спорную ситуацию.',

  empty: {
    title: 'Записей нет',
    text: 'Журнал заполняется сам, когда администрация что-то меняет.',
  },

  /**
   * Подписи действий. Вложены так же, как имя действия на сервере
   * (`user.create`), — точка в i18next разделяет ключи, плоским ключом её не
   * написать.
   */
  event: {
    user: {
      create: 'Добавлен в список участников',
      register: 'Записался сам',
      update: 'Изменена запись участника',
      revoke: 'Снят доступ',
      restore: 'Возвращён доступ',
      grant_slot: 'Выдан слот персонажа',
      bootstrap: 'Назначен первый суперадмин',
      data_deletion: 'Удалены свои данные',
    },
    character: {
      update: 'Изменён персонаж',
      archive: 'Персонаж убран в архив',
      /* Заморозки больше нет, а подпись остаётся: журнал — это история. */
      freeze: 'Персонаж заморожен',
      transfer: 'Персонаж передан',
      delete: 'Персонаж удалён',
    },
    config: {
      update: 'Изменена настройка',
    },
  },

  subject: {
    user: 'Участник',
    character: 'Персонаж',
    setting: 'Настройка',
  },

  filter: {
    subject: 'Объект',
    setting: 'Настройки',
  },

  snapshot: {
    before: 'Было',
    after: 'Стало',
  },

  action: {
    details: 'Подробности',
    hideDetails: 'Скрыть подробности',
  },
} as const;
